import { render, staticRenderFns } from "./ObracunStimulacijeReport.vue?vue&type=template&id=bc0779c6&scoped=true&"
import script from "./ObracunStimulacijeReport.vue?vue&type=script&lang=ts&"
export * from "./ObracunStimulacijeReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0779c6",
  null
  
)

export default component.exports